export enum PageNavigationType {
    DASHBOARD = 1,
    PAYMENTS = 2,
    ORDERGUIDE = 3
}